import { Type } from '@angular/core';
import { Client } from './client.model';

import { ShiftRecord } from './shift-record.model';

export class WorkflowPage { 
    completedStatus: string; 
    nextPage: WorkflowPage;
    pageNumber: number;
    previousPage: WorkflowPage;  
    title: string;
    usePreviousShiftRecordInHeader: boolean;
    usePreviousDayInHeader: boolean;
    isSkippable: boolean;
    
    public constructor(public component: Type<any>, public shiftRecord: ShiftRecord, public client: Client, private fields?: Partial<WorkflowPage>) { 
        // Normally, this would use Object.assign(this, fields); however, 
        // internet explorer doesn't support it so properties are explicitly assigned instead.     
        if (fields) {
            this.completedStatus = fields.completedStatus ? fields.completedStatus : "";
            this.nextPage = fields.nextPage ? fields.nextPage : null;
            this.pageNumber = fields.pageNumber ? fields.pageNumber : 0;
            this.previousPage = fields.previousPage ? fields.previousPage : null;
            this.title = fields.title ? fields.title : "";
            this.usePreviousShiftRecordInHeader = fields.usePreviousShiftRecordInHeader;
            this.usePreviousDayInHeader = fields.usePreviousDayInHeader;
            this.isSkippable = fields.isSkippable;
            
        }
    }
}